import { render, staticRenderFns } from "./NeoparentEditProfile.vue?vue&type=template&id=90ec07ce&scoped=true"
import script from "./NeoparentEditProfile.vue?vue&type=script&lang=js"
export * from "./NeoparentEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ec07ce",
  null
  
)

export default component.exports